import { ZiroCheckboxComponent } from '../../../../forms/fields/checkbox/ziro-checkbox.component';
import { Component } from '@angular/core';
import { ZiroFieldAbstractDirective } from '../../../../forms/ziro-field-abstract.directive';

@Component({
  selector: 'ziro-general-settings-checkbox',
  templateUrl: './general-settings-checkbox.component.html',
  styleUrls: ['./general-settings-checkbox.component.scss'],
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: GeneralSettingsCheckboxComponent }],
  standalone: false,
})
export class GeneralSettingsCheckboxComponent extends ZiroCheckboxComponent {}
